import React, { useEffect } from 'react'

//Importing Styles
import './aboutUsPageStyle.css'
import { Link } from 'react-router-dom';

const AboutUsPage = ({ states, toggleModes }) => {

  //Makes sure that when the page is loaded, it scroll to the top smmoothly
  useEffect(() => {
    window.scrollTo(0, 0, {
      behavior: 'smooth'
    });
  }, []);

  const chooseUsData = [
    {
      front: 'Expertise',
      back: 'Our team of professionals brings a wealth of knowledge and experience in various domains of business law and finance.',
    },
    {
      front: 'Client Focus',
      back: 'Your success is our success. We work closely with you to understand your needs and deliver solutions that align with your business objectives.',
    },
    {
      front: 'Proactive\nApproach',
      back: 'We anticipate and address potential issues before they become problems, keeping you ahead of regulatory changes.',
    },
  ];

  return (
    <>
      {/* About Us Banner Section */}
      <div className={toggleModes.state === "light" ? 'aboutus_banner_container' : 'aboutus_banner_container dark'}>
        <div className='overlay'></div>

        <div className='aboutus_banner_content'>
          <h1>Our performance is your success.</h1>
          <p>We are a team of passionate individuals dedicated to providing the best service possible.</p>
          <div className='aboutus_banner_buttons'>
            {/* <a href='#'>Contact Us</a> */}
            <Link onClick={() => { states('#contact'); }} to="/">Contact Us</Link>
            <Link to='/services&pricing'>Our Services</Link>
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <div id='about' className={toggleModes.state === "light" ? "aboutus_section" : "aboutus_section dark"}>
        <div className='aboutus_content'>
          <h1>About <span>Us</span></h1>
          <p>Welcome to <strong>Finera</strong> - Your Trusted Partner for Business Legal Solutions! <br /> <br />

            At <i><strong>Finera</strong></i>, we are dedicated to providing comprehensive and reliable legal solutions tailored to meet the diverse needs of businesses. Founded with the mission to simplify the complexities of legal compliance and regulatory requirements, we aim to be your go-to resource for all things legal and financial.
            <br />
            <i><strong>Finera</strong></i> was founded with a singular vision: to empower businesses by providing them with comprehensive, reliable, and efficient legal and financial solutions. Our team is comprised of seasoned professionals with extensive experience in tax consultancy, legal compliance, and business advisory services. We pride ourselves on our in-depth knowledge and commitment to excellence, which allows us to deliver top-notch services to our clients.
          </p>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className={toggleModes.state === "light" ? 'aboutus_chooseus_section' : 'aboutus_chooseus_section dark'}>
        <div className='heading'>
          <h4>Why <span>Choose</span> Us?</h4>
          <p>Simplifying legal and financial complexities so businesses can grow.</p>
        </div>
        <div className='content'>
          {chooseUsData.map((item, idx) => (
            <div className='chooseus_card' key={idx}>
              <div className='chooseus_card_inner'>
                <div className='chooseus_card_front'>
                  <div className='overlay'></div>
                  <p>{item.front}</p>
                </div>
                <div className='chooseus_card_back'>{item.back}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Our Vision Section - Similar to About us Section */}
      <div id='about' className={toggleModes.state === "light" ? "aboutus_section" : "aboutus_section dark"}>
        <div className='aboutus_content'>
          <h1>Our <span>Vision</span></h1>
          <p> At <strong>FINERA</strong>, our vision is to be the most
            trusted and innovative legal solutions
            pa ner for businesses. We strive to
            create a secure and compliant business
            environment where companies can
            operate with con dence, free from legal
            unce ainties. Through our expe ise,
            integrity, and commitment to excellence,
            we aim to set new standards in business
            legal consulting, ensuring long-term
            success for our clients
          </p>
        </div>
      </div>

      {/* Our Mission Section */}
      <div className={toggleModes.state === "light" ? 'aboutus_ourmission_section' : 'aboutus_ourmission_section dark'}>
        <div className='overlay'></div>

        <div className='heading'>
          <h4>Our <span>Mission</span></h4>
          <p>Secure Legal Solutions. Confident Business Growth.</p>
        </div>

        <div className='content'>
          <div className='ourmission_card'>
            <h4>Expert Legal Guidance with Confidence</h4>
            <p>We help businesses navigate complex regulations with ease, providing clear, ethical, and expert legal support tailored to their unique needs.</p>
          </div>
          <div className='ourmission_card'>
            <h4> Risk Mitigation & Compliance</h4>
            <p>Our legal solutions are designed to reduce risks, ensure compliance, and safeguard business interests—allowing clients to operate securely.</p>
          </div>
          <div className='ourmission_card'>
            <h4>Empowering Growth Through Partnership</h4>
            <p>By offering proactive counsel and strategic partnerships, we empower companies to focus on innovation and scale confidently.</p>
          </div>
        </div>
      </div>

      {/* Our Team Section */}
      {/* <div className={toggleModes.state === "light" ? 'ourteam_section' : 'ourteam_section dark'}>
        <h4 className='ourteam_heading'>Our <span>Team</span></h4>
        <p className='ourteam_heading'>Meet the dedicated professionals behind Finera.</p>

        <div className='ourteam_content'>
          <h4>Founders</h4>
          <div className='founders'>
            <div className='ourteam_card'>
              <div className='ourteam_card_inner'>
                <div className='ourteam_card_front'>
                  <div className='overlay'></div>
                  <div className='front_content'>
                    <h4>John Doe</h4>
                    <p>CEO & Founder</p>
                  </div>
                </div>
                <div className='ourteam_card_back'>
                  <h4>John Doe</h4>
                  <p>
                    Materials Expert<br />
                    B.Tech in Civil from Heritage College.<br />
                    M.Tech in Ceramics from GCECT<br />
                    2 Year’s Experience in Construction Industry.<br />
                    Research Scholar<br />
                    Patent Holder
                  </p>
                </div>
              </div>
            </div>

            <div className='ourteam_card'>
              <div className='ourteam_card_inner'>
                <div className='ourteam_card_front'>
                  <div className='overlay'></div>
                  <div className='front_content'>
                    <h4>John Wick</h4>
                    <p>Co-Founder</p>
                  </div>
                </div>
                <div className='ourteam_card_back'>
                  <h4>John Wick</h4>
                  <p>
                    Materials Expert<br />
                    B.Tech in Civil from Heritage College.<br />
                    M.Tech in Ceramics from GCECT<br />
                    2 Year’s Experience in Construction Industry.<br />
                    Research Scholar<br />
                    Patent Holder
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Visit Us Section */}
      <div className={toggleModes.state === "light" ? 'visitus_section' : 'visitus_section dark'}>
        <h4 className='visitus_heading'>Visit <span>Us</span></h4>
        <div className='content_container'>
          <div className='content'>
            <div>
              <h6>Office <span>Location</span></h6>
              <p>61X, Topsia Rd, Topsia, Kolkata, West Bengal 700039</p>
            </div>

            <div>
              <h6>Opening <span>Hours</span></h6>
              <p>Mon-Sat: 10:00 AM to 8:00 PM <br /> Sun: Closed <br /> *On Holiday Occassions hours may vary*</p>
            </div>

            <div className='contact_gmail'>
              <p>Contact: <span style={{ fontSize: 20 }}>contact@finera.net.in</span></p>
            </div>
          </div>
          <div className='map'>
            <iframe title='MAP' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.156009049776!2d88.38534201113448!3d22.535827934231094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027786cf5b3573%3A0x850ad0a527d38532!2sFinera!5e0!3m2!1sen!2sin!4v1724059741364!5m2!1sen!2sin" width={600} height={450} style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </div>
    </>
  )
}

export default AboutUsPage